import { FC } from 'react';
import { DATA_ROOM_ACTIVITY_WINDOW_DAYS, DataRoomActivityWindow } from 'shared';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';

const WINDOWS = Object.values(DataRoomActivityWindow);

/**
 * 20.1.1 §2 and 20.1.2 §3/§6: three fixed windows, defaulting to 7 days, and each tab holds its
 * own — which is why this takes the value rather than reading a store of its own.
 */
export const ActivityWindowToggle: FC<{
  onChange: (window: DataRoomActivityWindow) => void;
  value: DataRoomActivityWindow;
}> = ({ onChange, value }) => (
  <div className="flex h-9 overflow-hidden rounded border border-gray-200 shadow-[0px_1px_1px_0px_rgba(16,24,40,0.05)]">
    {WINDOWS.map((window) => (
      <Button
        aria-pressed={window === value}
        className={twMerge(
          'h-full w-fit rounded-none bg-white px-4 py-2 text-sm font-normal leading-5 text-gray-500 transition-colors duration-200 ease-out hover:bg-gray-25 [&:not(:last-child)]:border-r [&:not(:last-child)]:border-gray-200',
          window === value && 'bg-gray-50 font-[550] text-gray-700',
        )}
        key={window}
        onClick={() => onChange(window)}
        styleType="NONE"
      >
        <AppFormattedMessage
          id="DAYS_COUNT_SHORT"
          values={{ count: DATA_ROOM_ACTIVITY_WINDOW_DAYS[window] }}
        />
      </Button>
    ))}
  </div>
);
